import React from 'react';
import { caseTypeCommonFields } from '../CaseFormFields';


function AdditionalFields({
    additionalFields
}) {
  return (

        caseTypeCommonFields.map((item) => (
            item.fields.map((i) => {

            if(additionalFields?.[i.name])
            {
                    return (
                    <div className='flex justify-between gap-4 py-2.5 border-b border-[rgba(20,33,61,.08)] last:border-b-0 text-[13px]'>
                        <div className='text-[rgba(20,33,61,.55)]'>{i.label} </div>
                        <div className='text-navy font-medium text-right'>{additionalFields?.[i.name]}</div>
                    </div>
                    )

            }}
            )
        ))
  )
}

export default AdditionalFields
